//?imports
import {
  useState,
  useEffect,
  useContext,
} from "react";
import { AuthContext } from "../../store/auth-context";
//? styles
import styles from "./Tour.module.css";
const Tour = (props) => {
  const tourCtx = useContext(AuthContext);
  const { id, image, info, name, price } = props;
  const [isReadMore, setReadMore] =
    useState(false);
  const [isReadLess, setReadLess] =
    useState(false);
  const [Info, setInfo] = useState("");
  const infoLength = info.length;
  useEffect(() => {
    if (infoLength > 199) {
      const slicedInfo = info.slice(0, 200);
      setReadMore(true);
      setInfo(slicedInfo + "...");
    }
  }, [infoLength, info]);
  const readMoreHandler = () => {
    setInfo(info);
    setReadMore(false);
    setReadLess(true);
  };
  const showLessHandler = () => {
    setReadMore(true);
    setReadLess(false);
    const slicedInfo = info.slice(0, 200);
    setInfo(slicedInfo + "...");
  };

  return (
    <section className={styles["tour-container"]}>
      <div
        className={styles["image-container"]}
        style={{
          backgroundImage: `url(${image})`,
        }}
      ></div>
      <div
        className={styles["tour-name-container"]}
      >
        <h3 className={styles["name"]}>{name}</h3>
        <h3 className={styles["price"]}>
          {"$ " + price}
        </h3>
      </div>
      <div className={styles["info-container"]}>
        {<p>{Info}</p>}
        {isReadMore && (
          <span onClick={() => readMoreHandler()}>
            Read More
          </span>
        )}
        {isReadLess && (
          <span onClick={() => showLessHandler()}>
            Show Less
          </span>
        )}
      </div>

      <button
        className={styles["button"]}
        type="button"
        onClick={() => tourCtx.onDeleteTour(id)}
      >
        Not Interested
      </button>
    </section>
  );
};

export default Tour;
